<template>
  <BaseTemplate class="bg_white pb48">
    <div class="pt20 pl16 pr16">
      <BaseBackButton :text="'戻る'" :route="'/keepgoing'" />
    </div>

    <img :src="require('@/assets/images/keepgoing/present_options.png')" alt="">
  </BaseTemplate>
</template>

<script>
import BaseTemplate from "@/views/common/BaseTemplate.vue";
import BaseBackButton from "@/components/common/BaseBackButton.vue";
export default {
  components: {
    BaseTemplate,
    BaseBackButton
  },
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/keepgoing/ProductList.vue